"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.planetsPower = void 0;
var defs_1 = require("./defs");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var astro_utils_1 = require("./astro-utils");
var AspectsPatterns_1 = require("./AspectsPatterns");
var JonesPatterns_1 = require("./JonesPatterns");
function createCounterTable(en) {
    var result = {};
    Object
        .keys(en)
        .map(function (p) { return en[p]; })
        .filter(function (p) { return typeof p === 'number'; })
        .forEach(function (k) { return result[k] = 0; });
    return result;
}
function planetsPower(data, debug) {
    var _a;
    if (debug === void 0) { debug = false; }
    var aspects = data.aspects.filter(function (a) { return a.obj1 <= defs_1.ObjectType.Pluto && a.obj2 <= defs_1.ObjectType.Pluto; });
    var patterns = new AspectsPatterns_1.AspectsPatterns(aspects).findPatterns();
    if (debug)
        console.log(patterns);
    var power = createCounterTable(constants_1.planets);
    var objLon = function (obj) { return obj >= defs_1.ObjectType.House1 ? data.houses[obj - defs_1.ObjectType.House1] : data.objects[obj].lon; };
    var addPower = function (p, v) {
        if (p <= defs_1.ObjectType.Pluto) {
            power[p] += v;
        }
    };
    var prevPower = __assign({}, power);
    var printTable = function (msg) {
        if (msg === void 0) { msg = ''; }
        if (!debug)
            return;
        var changed = [];
        Object
            .keys(power)
            .map(function (p) { return parseInt(p); })
            .forEach(function (p) {
            if (power[p] !== prevPower[p]) {
                changed.push({
                    name: constants_1.astroObjects[p].en,
                    diff: power[p] - prevPower[p]
                });
            }
        });
        changed
            .forEach(function (p) { return console.log("".concat(p.name, ": ").concat(p.diff)); });
        console.log(Object
            .keys(power)
            .map(function (k) { return power[parseInt(k)]; }));
        prevPower = __assign({}, power);
    };
    var asp60 = (0, astro_utils_1.filterAspectsByType)(aspects, [defs_1.AspectType.Sextile]);
    var asp90 = (0, astro_utils_1.filterAspectsByType)(aspects, [defs_1.AspectType.Square]);
    var asp120 = (0, astro_utils_1.filterAspectsByType)(aspects, [defs_1.AspectType.Trine]);
    var asp180 = (0, astro_utils_1.filterAspectsByType)(aspects, [defs_1.AspectType.Opposition]);
    if (data.houses.length) {
        addPower(constants_1.dispositors[(0, astro_utils_1.getSign)(data.houses[0])][0], 4);
    }
    printTable('1');
    {
        var disp = constants_1.dispositors[(0, astro_utils_1.getSign)(data.objects[defs_1.ObjectType.Sun].lon)];
        addPower(disp[0], 4);
        if (disp.length === 2) {
            addPower(disp[1], 3);
        }
    }
    printTable('2');
    {
        var disp = constants_1.dispositors[(0, astro_utils_1.getSign)(data.objects[defs_1.ObjectType.Moon].lon)];
        addPower(disp[0], 4);
        if (disp.length === 2) {
            addPower(disp[1], 3);
        }
    }
    printTable('3');
    constants_1.planets.forEach(function (p) {
        var keepers = new Set();
        (0, astro_utils_1.getObjectHouses)(data.objects[p].lon, data.houses, false)
            .forEach(function (h) {
            if (h === 0) {
                addPower(p, 5);
            }
            constants_1.dispositors[h]
                .forEach(function (d) { return keepers.add(d); });
        });
        if (keepers.has(p)) {
            addPower(p, 3);
        }
    });
    printTable('4,5');
    constants_1.planets.forEach(function (p) {
        var disp = constants_1.dispositors[(0, astro_utils_1.getSign)(data.objects[p].lon)];
        if (disp.includes(p)) {
            addPower(p, p < defs_1.ObjectType.Jupiter ? 3 : 1);
        }
    });
    printTable('6');
    {
        var nums_1 = createCounterTable(defs_1.SignType);
        constants_1.planets.forEach(function (p) { return nums_1[(0, astro_utils_1.getSign)(data.objects[p].lon)]++; });
        Object
            .keys(nums_1)
            .map(function (s) { return +s; })
            .forEach(function (sign) {
            if (nums_1[sign] >= 3) {
                addPower(constants_1.dispositors[sign][0], 4);
            }
        });
    }
    printTable('7');
    {
        var southLon_1 = data.objects[defs_1.ObjectType.SouthNode].lon;
        var southSign_1 = (0, astro_utils_1.getSign)(southLon_1);
        constants_1.planets.forEach(function (p) {
            var lon = data.objects[p].lon;
            var angle = (0, utils_1.getAngle)(lon, southLon_1);
            var sign = (0, astro_utils_1.getSign)(lon);
            if (p === defs_1.ObjectType.SouthNode) {
                return;
            }
            if (sign === southSign_1 && angle <= 5 ||
                sign !== southSign_1 && angle <= 3) {
                addPower(p, 2);
            }
        });
    }
    printTable('8');
    (0, JonesPatterns_1.getHandles)(data, [JonesPatterns_1.JonesPatternType.Basket, JonesPatterns_1.JonesPatternType.Sling]).forEach(function (p) { return addPower(p.id, 2); });
    printTable('9');
    var onlyOnce = new Set();
    var addOnlyOnce = function (p) {
        if (!onlyOnce.has(p)) {
            addPower(p, 2);
            onlyOnce.add(p);
        }
    };
    constants_1.planets.forEach(function (p) {
        var op = (0, astro_utils_1.findOppositePlanets)(p, asp60);
        asp120.forEach(function (a) {
            if (op.includes(a.obj1) && op.includes(a.obj2)) {
                addOnlyOnce(p);
            }
        });
    });
    printTable('10');
    constants_1.planets.forEach(function (p) {
        var op = (0, astro_utils_1.findOppositePlanets)(p, asp90);
        asp180.forEach(function (a) {
            if (op.includes(a.obj1) && op.includes(a.obj2)) {
                addOnlyOnce(p);
            }
        });
    });
    printTable('11');
    var sails = new Set();
    var sailors = new Set();
    constants_1.planets.forEach(function (p) {
        var op60 = (0, astro_utils_1.findOppositePlanets)(p, asp60);
        var op120 = (0, astro_utils_1.findOppositePlanets)(p, asp120);
        asp180
            .filter(function (a) {
            return op60.includes(a.obj1) && op120.includes(a.obj2) ||
                op60.includes(a.obj2) && op120.includes(a.obj1);
        })
            .forEach(function (a) {
            addOnlyOnce(p);
            var _a = op60.includes(a.obj1) ? [a.obj1, a.obj2] : [a.obj2, a.obj1], p1 = _a[0], p2 = _a[1];
            var inter = (0, utils_1.intersection)((0, astro_utils_1.findOppositePlanets)(p1, asp60), (0, astro_utils_1.findOppositePlanets)(p2, asp120))
                .filter(function (_p) { return _p !== p && (0, utils_1.getAngle)(objLon(_p), objLon(p)) >= 100; });
            if (inter.length === 1) {
                var key = Array.from(new Set(__spreadArray(__spreadArray([], inter, true), [p1, p2, p], false))).sort().join(',');
                if (!sails.has(key)) {
                    var addSailor = function (p) {
                        if (!sailors.has(p)) {
                            addPower(p, 2);
                            sailors.add(p);
                        }
                    };
                    addSailor(p1);
                    addSailor(p2);
                    sails.add(key);
                }
            }
        });
    });
    printTable('12,13');
    if (data.houses.length) {
        var res = -1;
        for (var _i = 0, planets_1 = constants_1.planets; _i < planets_1.length; _i++) {
            var p = planets_1[_i];
            if ((0, utils_1.getAngle)(data.objects[p].lon, data.houses[9]) <= 20) {
                if (res === -1) {
                    res = p;
                }
                else {
                    res = -1;
                    break;
                }
            }
        }
        if (res !== -1) {
            for (var _b = 0, planets_2 = constants_1.planets; _b < planets_2.length; _b++) {
                var p = planets_2[_b];
                if (p !== res && (0, utils_1.getAngle)(data.objects[p].lon, data.objects[res].lon) <= 20) {
                    res = -1;
                    break;
                }
            }
        }
        if (res !== -1) {
            addPower(res, 2);
        }
    }
    printTable('14');
    {
        var nums_2 = createCounterTable(constants_1.planets);
        data.aspects.forEach(function (a) {
            if (constants_1.majorAspects.includes(a.type) &&
                a.obj1 <= defs_1.ObjectType.Pluto &&
                a.obj2 <= defs_1.ObjectType.Pluto) {
                nums_2[a.obj1] += 2;
                nums_2[a.obj2] += 2;
            }
        });
        var arr = Object
            .keys(nums_2)
            .map(function (n) { return +n; })
            .map(function (key) { return ({
            key: key,
            value: nums_2[key]
        }); })
            .sort(function (a, b) { return b.value - a.value; });
        if (arr[0].value >= arr[1].value + 4) {
            addPower(arr[0].key, 2);
        }
    }
    printTable('15');
    data
        .aspects
        .forEach(function (a) {
        if (a.type === defs_1.AspectType.Conjunction &&
            !(a.obj1 === defs_1.ObjectType.Sun && a.obj2 === defs_1.ObjectType.Moon ||
                a.obj2 === defs_1.ObjectType.Sun && a.obj1 === defs_1.ObjectType.Moon)) {
            if (a.obj1 <= defs_1.ObjectType.Moon) {
                addPower(a.obj2, 1);
            }
            else if (a.obj2 <= defs_1.ObjectType.Moon) {
                addPower(a.obj1, 1);
            }
        }
    });
    printTable('16');
    addPower(constants_1.dispositors[(0, astro_utils_1.getSign)(data.objects[defs_1.ObjectType.NorthNode].lon)][0], -2);
    printTable('17');
    var majorAspectsOnly = aspects.filter(function (a) { return constants_1.majorAspects.includes(a.type); });
    for (var p = defs_1.ObjectType.Jupiter; p <= defs_1.ObjectType.Pluto; p++) {
        if (!((0, astro_utils_1.findOppositePlanets)(p, majorAspectsOnly)
            .some(function (op) { return op <= defs_1.ObjectType.Mars; }) ||
            (0, astro_utils_1.getObjectHouses)(data.objects[p].lon, data.houses, false)
                .includes(0) ||
            ((_a = constants_1.dispositors[(0, astro_utils_1.getSign)(data.houses[0])]) === null || _a === void 0 ? void 0 : _a[0]) === p)) {
            power[p] = 0;
        }
    }
    printTable('filter');
    var result = [];
    {
        var order_1 = new Array(10).fill(0).map(function (_, i) { return i; });
        order_1[0] = 1;
        order_1[1] = 0;
        var sorted = Object
            .keys(power)
            .map(function (p) { return +p; })
            .map(function (p) { return ({
            p: p,
            v: power[p]
        }); })
            .filter(function (p) { return p.v > 0; })
            .sort(function (a, b) { return (b.v - a.v) || (order_1.indexOf(a.p) - order_1.indexOf(b.p)); });
        result.push.apply(result, sorted.slice(0, 4));
        if (sorted.length > 4 && sorted[4].v === sorted[3].v) {
            result.push(sorted[4]);
        }
    }
    return result;
}
exports.planetsPower = planetsPower;
